import React from 'react'
import '../css/serviceCard.css'

export default function ServicesCard({img,title,description} ) {
  return (
    // <div class="container">
    <div class="card text-center bg-transparent " data-aos="fade-up"  data-aos-easing="ease-out-cubic"
    data-aos-duration="1000" >
    <img src={img} class="card-img-top  d-flex w-100 " alt="test image" />
    <div class="card-body  ">
      <h5 class="card-title text-black ">{title} </h5>
      <p class="card-text  text-black fs-6 ">{description}</p>
     
    </div>
  </div>
  // </div>
  )
}
